import { ApiError } from "@/api/client";
import { fetchForm } from "@/api/forms";
import type { FormDto } from "@/types/form";
import { mergeFormSections } from "@/lib/forms/resolveFormSections";

export async function loadPublicForm(
  formId: string | number,
): Promise<FormDto> {
  try {
    const form = await fetchForm(formId, { auth: false });
    return form;
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) {
      return {
        id: Number.isFinite(Number(formId)) ? Number(formId) : 0,
        name: "Форма",
        is_closed: true,
        isClosed: true,
        closed_message: err.message,
        closedMessage: err.message,
        sections: [],
        fields: [],
      };
    }
    throw err;
  }
}

export async function loadPublicFormSchema(
  formId: string | number,
): Promise<FormDto> {
  const form = await loadPublicForm(formId);
  return {
    ...form,
    sections: mergeFormSections(form, []),
  };
}
